import React, { useState } from 'react';
import type { ReportsPageId, ReportsTimeRange } from '../../reports/types';
import { ReportsSubNav } from './ReportsSubNav';
import {
  BookingBarriersPage,
  CallIntentsPage,
  CompetitorIntelPage,
  EscalationCausesPage,
  KnowledgeGapsPage,
  PatientFAQsPage,
  PatientSourcesPage,
} from './ReportsPages';
import { WarmTransferPerformanceReportPage } from './WarmTransferPerformanceReportPage';
import './reports.css';

export interface ReportsViewProps {
  initialPage?: ReportsPageId;
}

export function ReportsView({ initialPage = 'booking-barriers' }: ReportsViewProps) {
  const [active, setActive] = useState<ReportsPageId>(initialPage);
  const [timeRange, setTimeRange] = useState<ReportsTimeRange>('7d');

  const pageProps = { timeRange, onTimeRangeChange: setTimeRange };

  const renderPage = () => {
    switch (active) {
      case 'booking-barriers':
        return <BookingBarriersPage {...pageProps} />;
      case 'competitor-intel':
        return <CompetitorIntelPage {...pageProps} />;
      case 'patient-sources':
        return <PatientSourcesPage {...pageProps} />;
      case 'call-intents':
        return <CallIntentsPage {...pageProps} />;
      case 'patient-faqs':
        return <PatientFAQsPage {...pageProps} />;
      case 'knowledge-gaps':
        return <KnowledgeGapsPage {...pageProps} />;
      case 'escalation-causes':
        return <EscalationCausesPage {...pageProps} />;
      case 'warm-transfer':
        return <WarmTransferPerformanceReportPage {...pageProps} />;
      default:
        return <BookingBarriersPage {...pageProps} />;
    }
  };

  return (
    <div className="rpt-root flex min-h-full w-full">
      <ReportsSubNav active={active} onChange={setActive} />
      <div className="min-w-0 flex-1 overflow-auto px-9 py-8 pb-[60px]">{renderPage()}</div>
    </div>
  );
}
